import React from 'react';

function Footer() {
  return (
    <div>
    <footer class="footer text-center">
    <div class="container">
      <p class="text-muted small mb-0">Copyright Comeaux Design and Elevate Tech Solutions 2020</p>
    </div>
  </footer>

  <a class="scroll-to-top rounded js-scroll-trigger" href="#page-top">
    <i class="fas fa-angle-up"></i>
  </a>
    </div>
  )
}

export default Footer